import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';

import App from './App';
import { msalConfig } from './config/authConfig';

export const msalInstance = new PublicClientApplication(msalConfig);

export default function SsoLogin() {
    return (
        <MsalProvider instance={msalInstance}>
            <App />
        </MsalProvider>
    );
}
